import { render, staticRenderFns } from "./RouterUpdater.vue?vue&type=template&id=1aefc533&scoped=true"
import script from "./RouterUpdater.vue?vue&type=script&lang=js"
export * from "./RouterUpdater.vue?vue&type=script&lang=js"
import style0 from "./RouterUpdater.vue?vue&type=style&index=0&id=1aefc533&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aefc533",
  null
  
)

export default component.exports